export default {
  shipments: {
    role: 'feature:shipments',
    displayName: 'Shipments'
  },
  globalShipments: {
    role: 'feature:global-shipments',
    displayName: 'Global shipments',
    description: 'Required for national user that are supposed to see inbound shipments'
  },
  packShipments: {
    role: 'feature:pack-shipments',
    displayName: 'Pack Shipments',
    description: 'User can move shipments to status packed'
  },
  lastMileDeliveries: {
    role: 'feature:lastMileDeliveries',
    displayName: 'Last Mile Deliveries',
    description: 'User can view last mile deliveries'
  }
}
